export default class TestData{

    constructor() {
        this.state = {

            currentPage: 1,                     // 回答中のページ数
            currentPageQuestion: 0,             // 当ページ：回答中の問題
            currentPageAnswers: {
                1:null,
                2:null,
                3:null,
                4:null,
                5:null,
                6:null,
                7:null,
                8:null,
                9:null,
                10:null,
                11:null,
                12:null,
                13:null,
                14:null,
                15:null,
            },             // 当ページ：回答済の回答内容（仮）
            currentPageAnswersFinal: 0,         // 当ページ：回答済の回答数（確定）

            completedQuestions: 0,              // 全ページ：回答済の問題数
            completedQuestionsPercentage: 0,    // 全ページ：回答済の問題数の比率

            answerStart: '',                    // 回答開始日時
            answerEnd: '',                      // 回答終了日時

            answerCompleted: '',                // 回答完了日時
            answerCanceled: '',                 // 回答中断日時

            nowQuestion:1,

        }
        this.questions = [
            // {no:1,active:true,question_left:'多少無理を感じてもでも重要な取引先の意向は大事にする',question_right:'重要な取引先には合理的であることを求める'},
            {no:1,active:true,question_left:'多少無理を感じても重要な取引先の意向は大事にする',question_right:'重要な取引先には合理的であることを求める'},
            // {no:2,active:false,question_left:'重要な取引先の要望を優先して信頼を得る',question_right:'重要な取引先とは効果的なビジネス展開の共有をお願いする'},
            {no:2,active:false,question_left:'重要な取引先の要望を優先して信頼を得る',question_right:'重要な取引先には効果的なビジネス展開の共有をお願いする'},
            {no:3,active:false,question_left:'重要な取引先の期待にはできる限り沿うように心がける',question_right:'重要な取引先とは対等な関係で合理的なビジョンを共有する'},
            {no:4,active:false,question_left:'重要な取引先の意向に沿う提案を大事にする',question_right:'市場環境を考慮した最適解を重要な取引先にご理解いただく'},
            // {no:5,active:false,question_left:'重要な取引先の満足度はできる限り確保する',question_right:'重要な取引先とは市況を共有して合理的なビジョンを共有する'},
            {no:5,active:false,question_left:'重要な取引先の満足度はできる限り確保する',question_right:'重要な取引先とは市況を互いに確認しながら合理的なビジョンを共有する'},
            // {no:6,active:false,question_left:'多少時間をかけてでも深く考えることが評価される',question_right:'とにかく迅速に行動することが評価される'},
            {no:6,active:false,question_left:'多少時間をかけてでも深く考えることを評価する',question_right:'とにかく迅速に行動することを評価する'},
            // {no:7,active:false,question_left:'新しい試みの成否の検討や緻密なデータ管理を徹底する',question_right:'デスクで考えすぎるより現場で行動することが評価される'},
            {no:7,active:false,question_left:'新しい試みの成否の検討や緻密なデータ管理を徹底する',question_right:'デスクで考えすぎるより現場で行動することを評価する'},
            {no:8,active:false,question_left:'この先の戦略を考えること、またはこれまでのデータの整理が成果につながる',question_right:'行動の量またはスピードが成果につながる'},
            // {no:9,active:false,question_left:'的確な情報の整理・収集、または先を見据えたアイディアが評価される',question_right:'労力を惜しまず、最後までやり切る力が評価される'},
            {no:9,active:false,question_left:'的確な情報の整理・収集、または先を見据えたアイディアを評価する',question_right:'労力を惜しまず、最後までやり切る力を評価する'},
            {no:10,active:false,question_left:'この先を展望し、この先のシナリオを描く',question_right:'今できることに集中してとことんやり遂げる'},
            {no:11,active:false,question_left:'同業他社だけでなく同僚ともいいライバル関係にある',question_right:'同僚、時には同業他社とも役割を分担できる関係にある'},
            {no:12,active:false,question_left:'必要であれば同業他社と、時には同僚とも競争する',question_right:'同僚、時には同業他社との助け合いを大事にする'},
            {no:13,active:false,question_left:'同業他社または同僚が未着手のチャンスは見逃さない',question_right:'業界の勢力関係や組織の年功序列などのバランスを重視する'},
            // {no:14,active:false,question_left:'同業他社よりも、時には同僚よりも成果を出すことを目指す',question_right:'同業他社や同僚と良好な関係を大事にする'},
            {no:14,active:false,question_left:'時には、同業他社や同僚よりも成果を出すことを目指す',question_right:'同業他社や同僚と良好な関係を大事にする'},
            // {no:15,active:false,question_left:'同業他社と、時には同僚とも必要ならば積極的に競う',question_right:'業界や組織の“しきたり”に沿って和を乱さない'},
            {no:15,active:false,question_left:'同業他社や同僚とも必要があれば積極的に競う',question_right:'業界や組織の“しきたり”に沿って和を乱さない'},
        ]
        this.lastQuestionElement = null
    }

    isAnswerCompleted(){
        return this.state.answerCompleted !== null
            && this.state.answerCompleted !== undefined
            && this.state.answerCompleted !== ''
    }

    // gggggggg(payload){
    //     if (payload) {
    //         this.currentPage = payload.currentPage;                                    // 回答中のページ数：1
    //         this.currentPageQuestion = payload.currentPageQuestion;                    // 当ページ：回答中の問題：0
    //         this.currentPageAnswers = payload.currentPageAnswers;                      // 当ページ：回答済の回答内容（仮）：[]
    //         this.currentPageAnswersFinal = payload.currentPageAnswersFinal;            // 当ページ：回答済の回答数（確定）：0
    //
    //         this.completedQuestions = payload.completedQuestions;                      // 全ページ：回答済の問題数：0
    //         this.completedQuestionsPercentage = payload.completedQuestionsPercentage;  // 全ページ：回答済の問題数の比率：0
    //
    //         this.answerStart = payload.answerStart;                                    // 回答開始日時
    //         this.answerEnd = payload.answerEnd;                                        // 回答終了日時
    //
    //         this.answerCompleted = payload.answerCompleted;                            // 回答完了日時
    //         this.answerCanceled = payload.answerCanceled;                              // 回答中断日時
    //
    //     } else {
    //         // 値をリセットする
    //         this.currentPage = 1;                                                      // 回答中のページ数
    //         this.currentPageQuestion = 0;                                              // 当ページ：回答中の問題
    //         this.currentPageAnswers = [];                                              // 当ページ：回答済の回答内容（仮）
    //         this.currentPageAnswersFinal = 0;                                          // 当ページ：回答済の回答数（確定）
    //
    //         this.completedQuestions = 0;                                               // 全ページ：回答済の問題数
    //         this.completedQuestionsPercentage = 0;                                     // 全ページ：回答済の問題数の比率
    //
    //         this.answerStart = '';                                                     // 回答開始日時
    //         this.answerEnd = '';                                                       // 回答終了日時
    //
    //         this.answerCompleted = '';                                                 // 回答完了日時
    //         this.answerCanceled = '';                                                  // 回答中断日時
    //     }
    //
    // }



    setCount(state, payload) {
        console.log("RRRRRRRRRRRRRRR : setCount");
        state.count = state.count + payload;
    }

    // increment ミューテーションを定義
    increment(state, payload) {
        console.log("RRRRRRRRRRRRRRR : increment");
        state.count = state.count + 1
    }

    hide(state, payload) {
        console.log("RRRRRRRRRRRRRRR : hide");
        state.overlay = false;
    }
    show(state, payload) {
        console.log("RRRRRRRRRRRRRRR : show");
        state.overlay = true;
    }

    // save(state, payload) {
    //     // Json 文字列に変換し LocalStorage へ保存
    //     localStorage.setItem('store', JSON.stringify(state))
    //     // localStorage.setItem('store', JSON.stringify(payload))
    // },
    load() {

        const enneagram_state = localStorage.getItem('enneagram_state')

        if (enneagram_state) {
            // state を置き換えます。
            this.state = JSON.parse(enneagram_state)
            // ※ ちなみに以下はNGです。stateプロパティは読み取り専用なので。
            // this.state = store
        }

        const enneagram_questions = localStorage.getItem('enneagram_questions')
        console.log(enneagram_questions)
        if (enneagram_questions) {
            // state を置き換えます。
            this.questions = JSON.parse(enneagram_questions)
        }

        const last_element = localStorage.getItem('last_element')
        console.log(last_element)
        if (last_element) {
            // state を置き換えます。
            this.lastQuestionElement = last_element
        }
    }

    /**
     * データをローカルストレージに保存
     */
    saveToLocalStorage(){
        localStorage.setItem('enneagram_state', JSON.stringify(this.state))
        localStorage.setItem('enneagram_questions', JSON.stringify(this.questions))
    }

    /**
     * 全ての質問が回答済みならtrue
     * @returns {boolean}
     */
    isAllAnswered(){
        const question_key_numbers = Object.entries(this.state.currentPageAnswers)

        for (let [question_no,answer_no] of question_key_numbers){
            if (this.state.currentPageAnswers[question_no] === null){
                //未選択の質問あり
                return false
            }
        }
        //全質問回答済み
        return true
    }
}
